import { type ComponentType, ReactNode } from 'react';

import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from './render-extension';

export interface ResourceLinkOptions {
  name: string;
  text: ReactNode;
  className?: string;
}

export type ResourceDisplayNameProps = {
  name: string;
  children: ReactNode;
};

export type ResourceLinkIcon =
  | 'chat'
  | 'entity'
  | 'factTable'
  | 'flag'
  | 'identity'
  | 'measurement'
  | 'metric'
  | 'project'
  | 'recording'
  | 'surface'
  | 'workflow';

export type ResourceLinkExtensionOptions =
  ItemRenderExtensionOptions<ResourceLinkOptions> & {
    DisplayName?: ComponentType<ResourceDisplayNameProps>;
    icon?: ResourceLinkIcon;
  };

export const ResourceLinkExtensions =
  createItemRenderExtensions<ResourceLinkExtensionOptions>({
    id: 'resource-link',
  });

export const createResourceLinkExtension = (
  options: ResourceLinkExtensionOptions,
) => {
  return createItemRenderExtension<ResourceLinkExtensionOptions>(options);
};

export const useResourceLinkExtensions = (): ResourceLinkExtensionOptions[] =>
  useItemRenderExtensions<ResourceLinkExtensionOptions>(ResourceLinkExtensions);
